import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MbscCalendarEvent, MbscDateType, MbscEventcalendarView, MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { datePickerOptions } from '../../../../interfaces/date-picker/date-picker.options';
import { GETEventService } from '../../../../services/fetchServices/fetchEvent/GET/get-event.service';
import { ThemeService } from '../../../../services/shared/theme.service';
import { getBacklogDropContainerOptions, getTemplateDropContainerOptions } from '../../../../interfaces/calender/admin/calender-event-functions';
import { FilterBacklogPopupComponent } from '../../popups/filter-backlog-popup/filter-backlog-popup.component';
import { FilterTemplatePopupComponent } from '../../popups/filter-template-popup/filter-template-popup.component';
import { DELETEEventService } from '../../../../services/fetchServices/fetchEvent/DELETE/delete-event.service';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { POSTEventService } from '../../../../services/fetchServices/fetchEvent/POST/post-event.service';
import { EventHistoryService } from '../../../../services/shared/event-history/event-history.service';
import { PUTEventService } from '../../../../services/fetchServices/fetchEvent/PUT/put-event.service';
import { ToastNotificationService } from '../../../../services/shared/toast-notification.service';
import { WebSocketService } from '../../../../services/web-socket.service';
import { EventPopupComponent } from "@tridimo/shared-ui";
import { GetCustomerService } from '../../../../services/fetchServices/fetchCustomer/GET/get-customer.service';
import { Resource } from '../../../../interfaces/resource';
import { FetchUserService } from '../../../../services/fetchServices/fetchUser/fetch-user.service';
import { ColorService } from '../../../../services/shared/color/color.service';
import { IconService } from '../../../../services/shared/icons/icon.service';
import { EventViewComponent } from "../event-view/event-view.component";
import { GetTraveltimeService } from '../../../../services/fetchServices/fetchTraveltime/POST/get-traveltime.service';
import { DateChangeService } from '../../../../services/shared/date-change.service';
import { sidebarData } from '../../../../interfaces/selectData';


type OnlineLinkItem = {
  platform: string;
  link: string;
  description: string;
};

@Component({
  selector: 'app-left-sidebar',
  imports: [MbscModule, FormsModule, CommonModule, FilterTemplatePopupComponent, FilterBacklogPopupComponent, EventPopupComponent, EventViewComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class LeftSidebarComponent implements OnInit, OnChanges{
  @Output() eventSelected = new EventEmitter<{ start: Date; end: Date }>();
  @Output() dateChanged = new EventEmitter<MbscDateType>();
  @Output() eventClicked = new EventEmitter<any>();
  @Output() moveToTemplateCompleted = new EventEmitter<void>();
  @Output() moveToBacklogCompleted = new EventEmitter<void>();
  @Output() pendingUpdate = new EventEmitter<{ id: string | number; time: number }>();
  @Output() backlogEventCreated = new EventEmitter<any>();
  @Output() backlogEventUpdated = new EventEmitter<any>();
  @Output() templateEventCreated = new EventEmitter<any>();
  @Output() templateEventUpdated = new EventEmitter<any>();
  @Input() selectedDateInput!: MbscDateType;
  @Input() filteredTasks: any[] = [];
  @Input() tasks: any[] = [];
  @Input() events: any[] = [];
  @Input() interpreter: any[] = [];
  @Input() teams: any[] = [];
  @Input() setDragColors!: (event: any) => void;
    @Input() resetDragColors!: (event: any) => void;
  @ViewChild(EventPopupComponent) sharedEventPopup!: EventPopupComponent;
  @ViewChild(FilterBacklogPopupComponent) backlogFilterResourcesPopup!: FilterBacklogPopupComponent;
  @ViewChild('backlogFilterButton') backlogFilterButton!: ElementRef;
  @ViewChild('backlogFilterButton') backlogAnchorElm!: ElementRef;
  @ViewChild(FilterTemplatePopupComponent) templateFilterResourcesPopup!: FilterTemplatePopupComponent;
  @ViewChild('templateFilterButton') templateFilterButton!: ElementRef;
  @ViewChild('templateFilterButton') templateAnchorElm!: ElementRef;
  calView: MbscEventcalendarView = { timeline: { type: 'month', eventList: true } };
  listEvents: MbscCalendarEvent[] = [];
  listView: MbscEventcalendarView = { agenda: { type: 'year', size: 5 } };
  timer?: ReturnType<typeof setTimeout>;
  selectedEvent: MbscCalendarEvent[] = [];
  displayResults = false;
  datePickerOptions = datePickerOptions;
  selectedDate: MbscDateType = new Date();
  sidebarVisible = true;
  originalEvents: MbscCalendarEvent[] = [];
  sidebarWidth: number = 300; 
  isResizing: boolean = false;
  minSidebarWidth: number = 330;
  maxSidebarWidth: number = 600;
  backlogDropContainerOptions = getBacklogDropContainerOptions(this, this.setDragColors);
  templateDropContainerOptions = getTemplateDropContainerOptions(this, this.setDragColors, this.resetDragColors);
  contBacklogBg = '';
  contTemplateBg = '';
  ticketBacklogOpen: boolean = true
  toggleStatusTemplate: boolean = true
  toggleStatusBacklog: boolean = true
  showDeleteButtonsFlag: boolean = false  
  showHistoryContainer: boolean = true
  showInterpreterSelection: boolean = false
  dragging: boolean = false;
  showTabContainer: boolean = false
  ontTemplateBg = '';
  templates: any[] = [];
  test: any[] = []
  filteredTemplates: any[] = [];
  filteredCustomers:any[] = [];
  tempEvent: MbscCalendarEvent = { title: '', start: new Date(), end: new Date(), resource: '' };
  popupAnchor: HTMLElement | undefined;
  customerArray: any
  startOfDay: any
  endOfDay: any
  inst: any;
  groupedHistory: any;
  myEvents: MbscCalendarEvent[] = [];
  isPopupOpen: boolean = false
  historyData: any[] = [];
  popupCloseAfterTemplatePost: boolean  = false;
  popupCloseAfterTemplateUpdate: boolean  = false;
  popupCloseAfterEventPost: boolean = false
  popupCloseAfterEventUpdate: boolean = false
  popupCloseAfterEventDelete: boolean  = false;
  myResources: Resource[] = [];
  originalEventData: any;
  travelTimeData: any = null;
  selectedSidebarShortcut: any;
  sidebarData = sidebarData;
  private dateChangeInProgress = false;
  private refreshInterval: any;
  private pendingUpdates = new Map<string | number, number>();
  private destroy$ = new Subject<void>();

  constructor(private getEventService: GETEventService, public themeService: ThemeService, private cdr: ChangeDetectorRef, private deleteEventFetchService: DELETEEventService,
    private postEventFetchService: POSTEventService, private eventHistoryService: EventHistoryService, private putEventFetchService: PUTEventService,
    private toastService: ToastNotificationService, private socketService: WebSocketService, private getCustomerService : GetCustomerService, private fetchUserService: FetchUserService,
    public colorService: ColorService, public iconService: IconService, public traveltimeService: GetTraveltimeService, public dateChangeService: DateChangeService
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async ngOnInit() {
    this.selectedSidebarShortcut = localStorage.getItem('sidebarShortcut') ?? localStorage.setItem('sidebarShortcut', 'ctrl+y');

    this.dateChangeService.selectedDate$
      .pipe(takeUntil(this.destroy$))
      .subscribe(date => {
        if (!date) return;
        this.selectedDate = date;
        this.onDateChange();
      });

    //this.onDateChange()
    this.toggleSidebar()
    const storedWidth = localStorage.getItem('sideBarWidth');
    if (storedWidth) {
      const parsedWidth = parseInt(storedWidth, 10);
      if (!isNaN(parsedWidth)) {
        this.sidebarWidth = parsedWidth;
      }
    }

    this.startOfDay = new Date();
    //this.endOfDay = this.startOfDay + 86399000;

    const year = this.startOfDay.getFullYear();
    const month = String(this.startOfDay.getMonth() + 1).padStart(2, "0");
    const day = String(this.startOfDay.getDate()).padStart(2, "0");

    this.startOfDay = `${year}-${month}-${day}`;
    this.endOfDay = this.startOfDay;

    this.cdr.detectChanges();

    this.socketOnNewTemplate()
    this.socketOnUpdateTemplate()
    this.socketOnDeleteTemplate()

  //   this.refreshInterval = setInterval(() => {
  //   this.fetchEventsInPresentedPeriod();
  // }, 300_000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.setDragColors) {
      this.backlogDropContainerOptions =
        getBacklogDropContainerOptions(
          this,
          this.setDragColors
        );
    }
    if (this.setDragColors || this.resetDragColors) {
      this.templateDropContainerOptions =
        getTemplateDropContainerOptions(
          this,
          this.setDragColors, this.resetDragColors
        );
    }
    if (changes['selectedDateInput']) {
      const prev = changes['selectedDateInput'].previousValue
        ? new Date(changes['selectedDateInput'].previousValue)
        : undefined;
      const curr = changes['selectedDateInput'].currentValue
        ? new Date(changes['selectedDateInput'].currentValue)
        : undefined;
    
      if (
        curr && prev &&
        (curr.getFullYear() !== prev.getFullYear() ||
         curr.getMonth() !== prev.getMonth() ||
         curr.getDate() !== prev.getDate())
      ) {
        this.selectedDate = curr;
        //this.onDateChange();
      }
    }
  
    if (changes['tasks'] && changes['tasks'].currentValue) {
      console.log('Tasks geändert:', changes['tasks'].currentValue);
    }
  
    if (changes['filteredTasks'] && changes['filteredTasks'].currentValue) {
    
      // gesperrte Kalendernamen
      const blockedNames = ['Absagen Kalender', 'Abrechnungs Kalender'];
    
      // IDs dieser Kalender dynamisch aus den Teams holen
      const blockedResourceIds: number[] = [];
    
      this.teams.forEach((team: any) => {
        if (team.children) {
          team.children.forEach((child: any) => {
            if (blockedNames.includes(child.name)) {
              blockedResourceIds.push(child.id);
            }
          });
        }
      });
    
      this.filteredTasks = changes['filteredTasks'].currentValue.filter((event: any) => {
      
        const idString = String(event.id);
        if (idString.includes('-')) {
          return false;
        }
      
        if (!event.resource) {
          return true;
        }
      
        const resources = Array.isArray(event.resource)
          ? event.resource
          : [event.resource];
      
        const containsBlockedResource = resources.some((r: any) =>
          blockedResourceIds.includes(Number(r))
        );
      
        return !containsBlockedResource;
      });
    }
  }


  async fetchEventsInPresentedPeriod() {
    console.log('5 Minütige Sidebar aktualisierung');
    await this.fetchTemplates();
    this.updateTemplateDates(this.startOfDay);
  }

socketOnNewTemplate() {
  this.socketService.onNewTemplate().subscribe((event) => {
    console.log('OnNewTemplate :', event)
    const raw = event.event;
    const myId = this.getUserId();
      if(myId === event.event.authorId){
        return;
      }

    this.processNewTemplate(raw, 'websocket')
  });
}


socketOnUpdateTemplate() {
  this.socketService.onUpdateTemplate().subscribe(async (event) => {
    console.log('OnUpdateTemplate :', event)
    const rawEvent = event.event;
    const pendingTime = this.pendingUpdates.get(rawEvent.id);

      console.log(this.pendingUpdates)
      if (pendingTime) {
          console.log('⛔ WS ignored (local update in progress)', rawEvent.id);
          //this.processUpdatedEvent(rawEvent, 'local');
          return;
      }
      this.processUpdatedTemplate(rawEvent, 'websocket');
    
  });
}

socketOnDeleteTemplate() {
  this.socketService.onDeleteEvent().subscribe((event) => {
    const deletedId = Number(event.event);

    if (!deletedId) {
      return;
    }

    this.filteredTemplates = this.filteredTemplates.filter(t => String(t.id) !== String(deletedId));
    this.filteredTemplates = [...this.filteredTemplates];

    this.cdr.detectChanges();
  });
}

processNewTemplate(raw: any, method: string){
  console.log('Template Update from ', method)
  let info = [];
    try {
      info = JSON.parse(raw.informations || '[]');
      if (!Array.isArray(info)) info = [];
    } catch {
      info = [];
    }

    if (typeof raw.customer === 'string') {
      raw.customer = JSON.parse(raw.customer);
    }

    const newEvent: MbscCalendarEvent = {
      authorId: raw.authorId,
      id: Number(raw.id),
      isTemplate: raw.isTemplate,
      title: raw.title,
      start: new Date(raw.start),
      end: new Date(raw.end),
      location: raw.location,
      color: raw.color,
      description: raw.description,
      cost: raw.cost,
      status: raw.status,
      category: raw.category,
      resource: raw.resource,
      type: raw.type,
      customer: raw.customer,
      createdAt: raw.created_at,
      bestaetigungsform: raw.bestaetigungsform,
      blocker: raw.blocker,
      blockerRef: raw.blockerRef,
      bufferAfter: raw.bufferAfter,
      bufferBefore: raw.bufferBefore,
      calculateTraveltime: raw.calculateTraveltime,
      deleted: raw.deleted,
      dolmetscher: raw.dolmetscher,
      einsatzzeit: raw.einsatzzeit,
      offeneTermine: raw.offeneTermine,
      online: raw.online,
      onlineLink: raw.onlineLink,
      recurringids: raw.recurringids,
      ticketno: raw.ticketno,
      traveltime: raw.traveltime,
      vorbereitungsmaterial: raw.vorbereitungsmaterial,
      vorbereitungsmaterialLink: raw.vorbereitungsmaterialLink,
      recurring: raw.recurring,
      recurringException: raw.recurringException,
      dialinTime: raw.dialinTime,
      minuteBased: raw.minuteBased,
      subtypes: raw.subtypes,
      informations: info,
      abrechnungArt: raw.abrechnungArt
    };

    const exists = this.filteredTemplates.some(t => String(t.id) === String(newEvent.id));

    if (exists) {
      this.filteredTemplates = this.filteredTemplates.map(t =>
        String(t.id) === String(newEvent.id) ? newEvent : t
      );
    } else {
      this.filteredTemplates = [...this.filteredTemplates, newEvent];
    }

    this.filteredTemplates.sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt));

    this.filteredTemplates = [...this.filteredTemplates];
    this.cdr.detectChanges();
}

processUpdatedTemplate(rawEvent: any, method: string){
  console.log('Template Update from ', method)
  let info = [];
    try {
      info = JSON.parse(rawEvent.informations || '[]');
    } catch {
      info = [];
    }

    if (typeof rawEvent.customer === 'string') {
      rawEvent.customer = JSON.parse(rawEvent.customer);
    }

    const updatedEvent: MbscCalendarEvent = {
      authorId: rawEvent.authorId,
      id: Number(rawEvent.id),
      isTemplate: rawEvent.isTemplate,
      title: rawEvent.title,
      start: new Date(rawEvent.start),
      end: new Date(rawEvent.end),
      location: rawEvent.location,
      color: rawEvent.color,
      description: rawEvent.description,
      cost: rawEvent.cost,
      status: rawEvent.status,
      category: rawEvent.category,
      resource: rawEvent.resource,
      type: rawEvent.type,
      customer: rawEvent.customer,
      createdAt: rawEvent.created_at,
      bestaetigungsform: rawEvent.bestaetigungsform,
      blocker: rawEvent.blocker,
      blockerRef: rawEvent.blockerRef,
      bufferAfter: rawEvent.bufferAfter,
      bufferBefore: rawEvent.bufferBefore,
      calculateTraveltime: rawEvent.calculateTraveltime,
      deleted: rawEvent.deleted,
      dolmetscher: rawEvent.dolmetscher,
      einsatzzeit: rawEvent.einsatzzeit,
      offeneTermine: rawEvent.offeneTermine,
      online: rawEvent.online,
      onlineLink: rawEvent.onlineLink,
      recurringids: rawEvent.recurringids,
      ticketno: rawEvent.ticketno,
      traveltime: rawEvent.traveltime,
      vorbereitungsmaterial: rawEvent.vorbereitungsmaterial,
      vorbereitungsmaterialLink: rawEvent.vorbereitungsmaterialLink,
      recurring: rawEvent.recurring,
      recurringException: rawEvent.recurringException,
      dialinTime: rawEvent.dialinTime,
      minuteBased: rawEvent.minuteBased,
      subtypes: rawEvent.subtypes,
      informations: info,
      abrechnungArt: rawEvent.abrechnungArt
    };

    const index = this.filteredTemplates.findIndex(
      t => t.id === updatedEvent.id
    );

    if (index !== -1) {
      this.filteredTemplates.splice(index, 1, updatedEvent);
    } else {
      this.filteredTemplates.push(updatedEvent);
    }

    console.log('TEMPLATES-->',this.filteredTemplates)
    this.cdr.detectChanges();
}



startResizing(event: MouseEvent) {
  event.preventDefault(); 
  document.body.classList.add('no-select');
  this.isResizing = true;
  document.addEventListener('mousemove', this.resizeSidebar);
  document.addEventListener('mouseup', this.stopResizing);
}

resizeSidebar = (event: MouseEvent) => {
  if (this.isResizing) {
    const newWidth = event.clientX;
    this.sidebarWidth = Math.min(this.maxSidebarWidth, Math.max(this.minSidebarWidth, newWidth));
    localStorage.setItem('sideBarWidth', this.sidebarWidth.toString());
  }
}

stopResizing = () => {
  this.isResizing = false;
  document.removeEventListener('mousemove', this.resizeSidebar);
  document.removeEventListener('mouseup', this.stopResizing);
}

private formatDate(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

  setDatePickerAfterEventClick(args: any) {
    const startOfDay = new Date(args.event.start);
    startOfDay.setHours(0, 0, 0, 0);
    this.selectedDate = startOfDay
  }

   closePopup() {
    // this.onDateChange()
    this.isPopupOpen = false;
  }

async onDateChange() {
  if (this.dateChangeInProgress) return;

  this.dateChangeInProgress = true;

  if (!this.selectedDate && this.selectedDateInput) {
    this.selectedDate = this.selectedDateInput;
  }

  if (!this.selectedDate) {
    console.error("Das übergebene Datum ist undefined.");
    this.dateChangeInProgress = false;
    return;
  }

  try {
    const startDate = this.toDate(this.selectedDate);
    
    startDate.setHours(0, 0, 0, 0);

    const startTs = startDate.getTime();
    const endTs = startTs + 86399000;

    this.startOfDay = startTs;
    this.endOfDay = endTs;

    this.dateChanged.emit(new Date(startDate));

    const year = startDate.getFullYear();
    const month = String(startDate.getMonth() + 1).padStart(2, "0");
    const day = String(startDate.getDate()).padStart(2, "0");

    const dateStr = `${year}-${month}-${day}`;

    await this.fetchTemplates();
    this.updateTemplateDates(new Date(startDate));

  } catch (e) {
    console.error(e);
  } finally {
    this.dateChangeInProgress = false;
  }
}
  
toDate(input: unknown): Date {
  if (input instanceof Date) return input;
  if (typeof input === 'string' || typeof input === 'number') return new Date(input);
  throw new Error('Ungültiger Typ für Datum');
}


updateTemplateDates(newDate: Date) {
  this.templates.forEach(template => {
    const originalStart = new Date(template.start);
    const originalEnd = new Date(template.end);
    template.start = new Date(newDate);
    template.start.setHours(originalStart.getHours(), originalStart.getMinutes(), originalStart.getSeconds(), originalStart.getMilliseconds());

    template.end = new Date(newDate);
    template.end.setHours(originalEnd.getHours(), originalEnd.getMinutes(), originalEnd.getSeconds(), originalEnd.getMilliseconds());
  });
  this.filteredTemplates = [...this.templates];
  // console.log('gefilterte Templates',this.filteredTemplates)
}


  // SIDEBAR EIN- UND AUSKLAPPEN
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const shortcut = this.sidebarData?.find(
      item => item.value === this.selectedSidebarShortcut
    );
  
    if (!shortcut || typeof shortcut.key !== 'string') {
      return;
    }
  
    if (
      typeof event.key !== 'string' ||
      event.key.toLowerCase() !== shortcut.key.toLowerCase() ||
      event.ctrlKey !== shortcut.ctrl ||
      event.shiftKey !== shortcut.shift ||
      event.altKey !== shortcut.alt
    ) {
      return;
    }
  
    event.preventDefault();
  
    if (this.sidebarVisible) {
      this.closeSidebar();
    } else {
      this.openSidebar();
    }
  }


  toggleSidebar() {
  
    this.toggleStatusBacklog = localStorage.getItem('toggleBacklog') !== 'false';
    this.toggleStatusTemplate = localStorage.getItem('toggleTemplate') !== 'false';
  const status =  sessionStorage.getItem('toggleSidebar')
  if(status === 'close') {
    this.closeSidebar()
  } else {
    this.openSidebar()
  }
}

closeSidebar() {
  sessionStorage.setItem('toggleSidebar', 'close')
  this.sidebarVisible = false
}

openSidebar() {
  sessionStorage.setItem('toggleSidebar', 'open')
  this.sidebarVisible = true
}

get singleDropActive(): boolean {
  return (this.toggleStatusBacklog && !this.toggleStatusTemplate) ||
         (!this.toggleStatusBacklog && this.toggleStatusTemplate);
}


 openMainPopupBacklogEvent() {
  const selected = new Date(this.selectedDate as any); 

  if (isNaN(selected.getTime())) {
    console.error('Ungültiges selectedDate:', this.selectedDate);
    return;
  }

  const twoHoursLater = new Date(selected.getTime() + 2 * 60 * 60 * 1000);
 this.showTabContainer = true
  const newEvent = {
    id: 'backlog_' + Date.now(),
    start: selected,
    end: twoHoursLater,
    resource: undefined,
    color: '#007bff',
    allDay: false,
  };
  this.tempEvent = newEvent;
  this.showInterpreterSelection = false
  this.showHistoryContainer = false
  this.sharedEventPopup.open('onBacklogCreated');
}


  openMainPopupTemplateEvent() {
    const now = new Date();
    const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);
  
    const newEvent = {
      id: 'template_' + Date.now(),
      start: now,
      end: twoHoursLater,
      resource: undefined,
      color: '#007bff',
      allDay: false
    };
    
    this.tempEvent = newEvent;
   console.log(this.tempEvent)
    this.showTabContainer = true
    this.showInterpreterSelection = false
    this.showHistoryContainer = false
    this.sharedEventPopup.open('onTemplateCreated');
  }

   openBacklogFilter() {
     this.popupAnchor = this.backlogAnchorElm.nativeElement;
     this.backlogFilterResourcesPopup.openBacklogFilter(this.popupAnchor)
  }

  openTemplateFilter() {
    this.popupAnchor = this.templateAnchorElm.nativeElement;
    this.templateFilterResourcesPopup.openTemplateFilter(this.popupAnchor)
  }

  openBacklogEvent(args: any) {
    this.originalEventData = JSON.parse(JSON.stringify(args));
    this.tempEvent = args;
    console.log('BACKLOG-EVENT',this.tempEvent)
    this.showTabContainer = false
    this.showHistoryContainer = true
    this.showInterpreterSelection = false
    this.sharedEventPopup.open('onBacklogClick');
    this.getHistoryData(this.originalEventData.id)
    this.customerSearchFiltering('')
  }

   showDeleteButtons() {
    if(this.showDeleteButtonsFlag) {
      this.showDeleteButtonsFlag = false
    } else {
      this.showDeleteButtonsFlag = true
    }
  }
// TEsten
//   showDeleteButtons() {
//   this.showDeleteButtonsFlag = !this.showDeleteButtonsFlag;
// }


  openTemplateEvent(args: any) {
    console.log(args)
    this.originalEventData = JSON.parse(JSON.stringify(args));
    this.tempEvent = args;
    this.showTabContainer = false
    this.showHistoryContainer = false
    this.showInterpreterSelection = false
    this.sharedEventPopup.open('onTemplateClick');
    this.customerSearchFiltering('')
  }

   async deleteTemplate(event: any) {
    
    this.filteredTemplates = this.filteredTemplates.filter(t => t.id !== event.id);
    this.filteredTemplates = [...this.filteredTemplates];
    this.cdr.detectChanges();
    try {
      await this.deleteEventFetchService.deleteEvent(event);
    } catch (e) {
      console.error('Löschen fehlgeschlagen', e);
    }
  }

  async fetchTemplates() {
      this.templates = [];
      this.filteredTemplates = []
      const templates = await firstValueFrom(this.getEventService.fetchTemplates());
      const eventPromises = templates.map(async (template: any) => {
        this.customerArray = JSON.parse(template.kunde);
        
        if (template.isTemplate === 1) {
          if (this.templates.some((e) => e.id === template.id)) {
            return;
          }
    
          const templateEvent = {
            authorId: template.authorId,
            id: template.id,
            isTemplate: template.isTemplate,
            title: template.title,
            start: new Date(template.start),
            end: new Date(template.end),
            location: template.location,
            color: template.color,
            description: template.description,
            cost: template.cost,
            status: template.status,
            category: template.category,
            resource: template.resource,
            type: template.type,
            customer: template.customer,
            createdAt: template.created_at,
            bestaetigungsform: template.bestaetigungsform,
            blocker: template.blocker,
            blockerRef: template.blockerRef,
            bufferAfter: template.bufferAfter,
            bufferBefore: template.bufferBefore,
            // calculateTraveltime: template.calculateTraveltime,
            calculateTraveltime: false,
            deleted: template.deleted,
            dolmetscher: template.dolmetscher,
            einsatzzeit: template.einsatzzeit,
            offeneTermine: template.offeneTermine,
            online: template.online,
            onlineLink: template.onlineLink,
            recurringids: template.recurringids,
            ticketno: template.ticketno,
            traveltime: template.traveltime,
            vorbereitungsmaterial: template.vorbereitungsmaterial,
            vorbereitungsmaterialLink: template.vorbereitungsmaterialLink,
            informations: template.informations,
            abrechnungArt: template.abrechnungArt
          };

          templateEvent.informations = JSON.parse(templateEvent.informations);
          
          this.templates.push(templateEvent);
          this.filteredTemplates = this.templates.sort((a, b) => a.start.getTime() - b.start.getTime());
          this.updateTemplateDates(this.startOfDay)
          this.templateFilterResourcesPopup.applyTemplateFilter();
        }
        return;
      });
    
      await Promise.all(eventPromises);
      return; 
    }


  async fetchEvents(startOfDay: any, endOfDay: any) {
    // console.log('TEMPLATES ZU BEGINN', this.templates);
    const toDateString = (ts: number): string => {
    const d = new Date(ts);
    // sorgt für führende Nullen bei Monat/Tag
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const startDate = toDateString(startOfDay);
  const endDate = toDateString(endOfDay);
    
    try {
      const events = await firstValueFrom(this.getEventService.fetchEvents(startDate, endDate));
      // console.log("Abgerufene Events:", events);

      const eventPromises = events.map(async (event: any) => {
        this.customerArray = event.customer;
        let cleanedObj
        
        if (event.recurring) {

          event.recurring.interval = parseInt(event.recurring.interval as any, 10) || null as any;

          if (event.recurring.count != null) {
            event.recurring.count = parseInt(event.recurring.count as any, 10) || null as any;
          }
        
          if (typeof event.recurring.until === 'string' && event.recurring.until.includes('T')) {
            event.recurring.until = event.recurring.until.split('T')[0]; // '2025-06-06'
          }

          let localExceptions: string[] = [];

          if (Array.isArray(event.recurringException)) {
            localExceptions = event.recurringException.map((entry: string) => {
              const date = new Date(entry as string); // sicher casten
              return date.toLocaleDateString('sv-SE'); // 'YYYY-MM-DD'
            });
            event.recurringException = localExceptions
          }
        
          if (event.recurring.until) {
            event.condition = 'until';
          } else if (event.recurring.count) {
            event.condition = 'count';
          } else {
            event.condition = 'never';
          }
        
          const obj = event.recurring;
          cleanedObj = Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined)
          );
        
          if (!this.isEmptyObject(cleanedObj)) {
            event.recurring = cleanedObj;
          } else {
            delete event.recurring;
          }
        }


          //if(event.online && !event.location && ['HOLIDAYEVENT', 'SICKEVENT', 'ILLNESSREPRESENTATIONEVENT', ].includes(event.type) ){
          //  event.calculateTraveltime = false
          //}else{
          //  event.calculateTraveltime = true
          //}

          let previousEventLocation;
          let earlierEvent;
          let bufferBefore;

          let nextEventLocation;
          let nextEvent;
          let bufferAfter;

          //OnlineLink check
          let platforms = [];

          platforms = this.normalizeOnlineLink(event.onlineLink);
          
          //Informations check
          let informations;

          if(event.informations !== ''){
            informations = JSON.parse(event.informations);
           
            if(informations === null){
              informations = ''
            }else if(informations.length === 0 && informations !== null){
              informations = '';
            }

          }else{
            informations = '';
          }

          return [{
            authorId: event.authorId,
            id: event.id,
            isTemplate: event.isTemplate,
            title: event.title,
            start: new Date(event.start),
            end: new Date(event.end),
            location: event.location,
            color: event.color,
            description: event.description,
            cost: event.cost,
            status: event.status,
            category: event.category,
            resource: event.resource,
            type: event.type,
            customer: event.customer,
            createdAt: event.created_at,
            bestaetigungsform: event.bestaetigungsform,
            blocker: event.blocker,
            blockerRef: event.blockerRef,
            bufferAfter: bufferAfter,
            bufferBefore: bufferBefore,
            calculateTraveltime: event.calculateTraveltime,
            deleted: event.deleted,
            dolmetscher: event.dolmetscher,
            einsatzzeit: event.einsatzzeit,
            offeneTermine: event.offeneTermine,
            online: event.online,
            onlineLink: platforms,
            recurringids: event.recurringids,
            ticketno: event.ticketno,
            traveltime: event.traveltime,
            vorbereitungsmaterial: event.vorbereitungsmaterial,
            vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
            recurring: event.recurring ? cleanedObj : undefined,
            recurringException: event.recurringException,
            condition: event.condition,
            previousEventLocation,
            hasEarlierSameDayEvent: !!earlierEvent,
            nextEventLocation,
            hasNextSameDayEvent: !!nextEvent,
            dialinTime: event.dialinTime,
            minuteBased: event.minuteBased,
            subtypes: event.subtypes,
            informations: informations,
            traveltimeBefore: event.traveltimeBefore,
            traveltimeAfter: event.traveltimeAfter
          }];
      });
      this.myEvents = (await Promise.all(eventPromises)).flat();
      this.cdr.detectChanges();
   
this.tasks = this.myEvents
  .filter((event: any) => {
    if (!event || !event.start || !event.end) return false;
    if (event.isTemplate !== 0) return false;

    const dolmetscherCount = Number(event.dolmetscher) || 0;

    let resourceCount = 0;
    let hasNullResource = false;
    if (Array.isArray(event.resource)) {
      const validResources = event.resource.filter((r: any) => {
        if (r === null) hasNullResource = true;
        return r != null;
      });
      resourceCount = validResources.length;
    } else if (typeof event.resource === 'number' || typeof event.resource === 'string') {
      resourceCount = 1;
    }

   let fremdDolmetscherCount = 0;

if (Array.isArray(event.informations)) {
  event.informations.forEach((info: any) => {
    const title = (info.title || info.icon_name || '').toLowerCase();

    if (
      (title.includes('fremd') && title.includes('dolmetscher')) ||
      title.includes('fremd-co') ||
      title.includes('fremddolmetscher')
    ) {
      if (info.checked) {
        if (Array.isArray(info.options) && info.options.length > 0) {
          fremdDolmetscherCount += info.options.length;
        } else {
          fremdDolmetscherCount += 0;
        }
      }
    }
  });
}

    const totalAssigned = resourceCount + fremdDolmetscherCount;
    const fehlendeDolmetscher = Math.max(0, dolmetscherCount - totalAssigned);

    const shouldGoToBacklog =
      hasNullResource ||
      resourceCount === 0 ||
      fehlendeDolmetscher > 0;

    event.resourceCount = resourceCount;
    event.fremdDolmetscherCount = fremdDolmetscherCount;
    event.totalAssigned = totalAssigned;
    event.fehlendeDolmetscher = fehlendeDolmetscher;
    event.hasNullResource = hasNullResource;


    return shouldGoToBacklog;
  })
  .map(event => {
    const startString = typeof event.start === 'string'
      ? event.start
      : event.start instanceof Date
        ? event.start.toISOString().slice(0, 16)
        : '2025-01-01T00:00';

    const endString = typeof event.end === 'string'
      ? event.end
      : event.end instanceof Date
        ? event.end.toISOString().slice(0, 16)
        : '2025-01-01T01:00';

    const startDate = new Date(startString);
    const endDate = new Date(endString);
    const durationInMinutes = (endDate.getTime() - startDate.getTime()) / 60000;
    const length = `${(durationInMinutes / 60).toFixed(1)} Std.`;

    return {
      ...event,
      start: event.start,
      end: event.end,
      length,
    };
  });

this.filteredTasks = this.tasks.sort((a, b) => a.start.getTime() - b.start.getTime());

    } catch (error) {
      console.error("Fehler beim Abrufen der Event-Daten (extern):", error);
    }
  }

  //  isEmptyObject(obj: unknown): obj is Record<string, never> {
  //   return (
  //     obj !== null &&
  //     typeof obj === "object" &&
  //     Object.keys(obj).length === 0
  //   );
  // }

  // TESTEN 
  isEmptyObject(obj: unknown): obj is Record<string, never> {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    Object.keys(obj).length === 0
  );
}


   onFilteredTasksChange(filtered: any[]) {
    this.filteredTasks = filtered;
  }

  onFilteredTemplateChange(filtered: any) {
    this.filteredTemplates = filtered;
  }
  
updateEventHistory(data: any) {
  console.log('original event data sidebar',this.originalEventData)
 this.eventHistoryService.compareAndUploadChanges(this.originalEventData, data, this.tempEvent.id, 'changed');   
}

// updateEventHistoryFromLib(data: any) {
//   console.log('history data in projekt', data)
//  this.eventHistoryService.compareAndUploadChanges(data[0], data[1], this.tempEvent.id, 'changed');   
// }
 // TESTEN
updateEventHistoryFromLib(data: any[]) {
  if (!Array.isArray(data) || data.length < 2 || !this.tempEvent?.id) {
    console.error('Ungültige History-Daten', data);
    return;
  }

  this.eventHistoryService.compareAndUploadChanges(
    data[0],
    data[1],
    this.tempEvent.id,
    'changed'
  );
}

  
   onEventDeleted(eventId: number) {
    this.myEvents = this.myEvents.filter(event => event.id !== eventId);
    
    this.filteredTemplates = this.filteredTemplates.filter(event => Number(event.id) !== eventId);
    this.cdr.detectChanges();
  }  

   async moveToBacklog(event: any) {
      if(event.isTempEvent){
    event.id = event.refId;
  }
  // console.log('event in update backlog : ', event);
  if (!this.tempEvent) {
    console.error('Fehler: Kein gültiges Event vorhanden!');
    return;
  }

  const startDate = new Date(event.start);
  const endDate = new Date(event.end);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  const startString = this.formatDate(startDate);
  const endString = this.formatDate(endDate);

  const oldResource = event.resource;
  event.resource = [];

  if (event.recurring === undefined) {
    event.recurring = null as any;
  }

  if (Array.isArray(event.customer)) {
    event.customer = event.customer
      .map((c: any) => (typeof c === 'object' ? c.id : c))
      .filter((id: any) => id != null && id !== '' && Number.isFinite(Number(id)))
      .map((id: any) => Number(id));
  } else if (event.customer && typeof event.customer === 'object') {
    event.customer = [event.customer.id];
  } else if (!event.customer) {
    event.customer = [];
  }

  let updatedResourceIds: any[] = [];

  if (Array.isArray(event.eventResources)) {
    if (event.eventResources.length === 1 && event.eventResources[0] === oldResource) {
      updatedResourceIds = [];
    } else {
      updatedResourceIds = event.eventResources.filter(
        (id: any) => id !== oldResource
      );
      if (updatedResourceIds.length === 0) {
        updatedResourceIds = [];
      }
    }
  } else {
    updatedResourceIds = [];
  }

  console.log('Neue Resource IDs für Update:', updatedResourceIds);

  //local update setzen
  this.pendingUpdate.emit({id: event.id, time: Date.now()});
  
  await this.putEventFetchService.updateEvent(
    event.title,
    event['location'],
    event['notes'],
    event.start,
    event.end,
    updatedResourceIds,
    event['description'],
    event['status'],
    event['ticketno'],
    event.customer,
    event['category'],
    event['id'],
    event.color,
    event['cost'],
    event['type'],
    event['online'],
    JSON.stringify(event['onlineLink']),
    event['dolmetscher'],
    event['vorbereitungsmaterial'],
    event['vorbereitungsmaterialLink'],
    event['bufferBefore'],
    event.bufferAfter,
    event['traveltime'],
    false,
    event['isTemplate'],
    event.recurring,
    event.recurringException,
    event.dialinTime,
    event.minuteBased,
    event.subtypes,
    JSON.stringify(event['informations']),
    event['popupEventTraveltimeBefore'],
    event['popupEventTraveltimeAfter'],
    event['einsatzzeit'],
    event['bestaetigungsform'],
    event.aufzeichnung,
    event.vorbereitung,
    event.vorbereitungZeit,
    event.abrechnungArt,
    event.fremdCoAbrechnung,
    event['ueberprueft'],
    event['resourceMeta']
    ).subscribe({
      next: (response:any) => {
        console.log('RESPONSE EVENT:', response);
        this.moveToBacklogCompleted.emit(response);
      },
      error: (err: any) => {
        console.error('Update failed:', err);
      }
    });
    await this.updateEventHistory(event);

    this.toastService.warningToast('Termin in Backlog verschoben');
    this.cdr.detectChanges();
}


async moveToTemplate(event: any) {
  
  const myId = this.getUserId();
  console.log('template in sidebar:', event)
  if (!event) {
    console.error('Fehler: Kein gültiges Event vorhanden!');
    return;
  }

  const startDate = new Date(event.start);
  const endDate = new Date(event.end);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(23, 59, 59, 999);

  // hier statt getTime → formatiertes Datum
  const startString = this.formatDate(startDate); // z.B. "2025-09-17"
  const endString = this.formatDate(endDate);     // z.B. "2025-09-17"

  // Neue Kopie erzeugen
  const templateEvent = structuredClone(event);
  templateEvent.isTemplate = 1;
  templateEvent.resource = undefined;
  templateEvent.id = 'template-' + Date.now();

   const onlineLinkString =
      templateEvent.onlineLink != null
        ? JSON.stringify(templateEvent.onlineLink)
        : '';

  if (Array.isArray(templateEvent.customer)) {
    templateEvent.customer = templateEvent.customer
      .map((c: any) => (typeof c === 'object' ? c.id : c))
      .filter((id: any) => id != null && id !== '' && Number.isFinite(Number(id)))
      .map((id: any) => Number(id));
  } else if (templateEvent.customer && typeof templateEvent.customer === 'object') {
    templateEvent.customer = [templateEvent.customer.id];
  } else if (!templateEvent.customer) {
    templateEvent.customer = [];
  }

  // speichern
  this.postEventFetchService.uploadTemplate(
    templateEvent.start, 
    templateEvent.end,
    templateEvent.title, 
    templateEvent['location'],
    templateEvent['cost'], 
    templateEvent['description'],
    templateEvent['category'], 
    templateEvent['status'], 
    templateEvent['ticketno'], 
    templateEvent['customer'], 
    templateEvent.color,
    templateEvent['vorbereitungsmaterial'],
    templateEvent['vorbereitungsmaterialLink'],
    templateEvent['online'],
    onlineLinkString,
    templateEvent['buffeBefore'], 
    templateEvent['bufferAfter'],
    templateEvent['traveltime'],
    false,
    templateEvent['type'],
    templateEvent['isTemplate'],
    templateEvent['popupEventTraveltimeBefore'],
    templateEvent['popupEventTraveltimeAfter'],
    templateEvent['informations'],
    templateEvent['aufzeichnung'],
    templateEvent['vorbereitung'],
    templateEvent['vorbereitungZeit'],
    templateEvent['abrechnungArt'],
    templateEvent['fremdCoAbrechnung'],
    templateEvent['bestaetigungsform'],
  ).subscribe({
      next: (response: any) => {

        if(myId === response.authorId){
          this.processNewTemplate(response, 'local')
        }
        
        },
        error: (err: any) => {
          console.error('Create failed:', err);
        }
      });

  setTimeout(() => {
    this.toastService.warningToast('Termin in Vorlagen kopiert');
    this.moveToTemplateCompleted.emit();
  }, 100);
}

normalizeOnlineLink(
    onlineLink: string | OnlineLinkItem[] | null | undefined
  ): OnlineLinkItem[] {
    // null/undefined -> leeres Array
    if (!onlineLink) {
      return [];
    }

    // Schon ein Array -> alle Einträge absichern
    if (Array.isArray(onlineLink)) {
      return onlineLink.map(item => ({
        platform: item.platform || 'Link',
        link: item.link || '',
        description: item.description || ''
      }));
    }

    // String -> versuchen zu parsen
    if (typeof onlineLink === 'string') {
      try {
        const parsed = JSON.parse(onlineLink);

        if (Array.isArray(parsed)) {
          // jedes Objekt absichern
          return parsed.map((item: any) => ({
            platform: item.platform || 'Link',
            link: item.link || '',
            description: item.description || ''
          }));
        } else {
          // falsches Format -> als einzelner Link behandeln
          return [{
            platform: 'Link',
            link: onlineLink,
            description: ''
          }];
        }
      } catch {
        // Fallback: war ein alter String-Link (nur URL)
        return [{
          platform: 'Link',
          link: onlineLink,
          description: ''
        }];
      }
    }

    // Sicherheits-Fallback
    return [];
  }

  postTemplateFromLib(event: any) {
    const myId = this.getUserId();

    console.log('template event post:', event)
    if (!event) {
      console.error('Fehler: Kein gültiges Event vorhanden!');
      return;
    }

    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    // hier statt getTime → formatiertes Datum
    const startString = this.formatDate(startDate); // z.B. "2025-09-17"
    const endString = this.formatDate(endDate);     // z.B. "2025-09-17"

    // Neue Kopie erzeugen
    const templateEvent = structuredClone(event);
    templateEvent.isTemplate = 1;
    templateEvent.resource = undefined;
    templateEvent.id = 'template-' + Date.now();

    const onlineLinkString =
      templateEvent.onlineLink != null
        ? JSON.stringify(templateEvent.onlineLink)
        : '';
  
    this.postEventFetchService.uploadTemplate(
      templateEvent.start, 
      templateEvent.end,
      templateEvent.title, 
      templateEvent.location,
      templateEvent.cost, 
      templateEvent.description,
      templateEvent.category, 
      templateEvent.status, 
      templateEvent.ticketno, 
      templateEvent.customer, 
      templateEvent.color,
      templateEvent.vorbereitungsmaterial,
      templateEvent.vorbereitungsmaterialLink,
      templateEvent.online,
      onlineLinkString,
      templateEvent.buffeBefore, 
      templateEvent.bufferAfter,
      templateEvent.traveltime,
      false,
      templateEvent.type,
      templateEvent.isTemplate,
      templateEvent.popupEventTraveltimeBefore,
      templateEvent.popupEventTraveltimeAfter,
      templateEvent.informations,
      templateEvent.aufzeichnung,
      templateEvent.vorbereitung,
      templateEvent.vorbereitungZeit,
      templateEvent.abrechnungArt,
      templateEvent.fremdCoAbrechnung,
      templateEvent.bestaetigungsform,
    ).subscribe({
      next: (response: any) => {

        if(myId === response.authorId){
          this.processNewTemplate(response, 'local')
        }
        
        },
        error: (err: any) => {
          console.error('Create failed:', err);
        }
      });

    setTimeout(() => {
      this.toastService.warningToast('Termin in Vorlagen kopiert');

      this.popupCloseAfterTemplatePost = true;
        setTimeout(() => (this.popupCloseAfterTemplatePost = false));
    }, 100);
  }

  updateTemplateFromLib(event: any) {
    const onlineLinkString =
    event.onlineLink != null
      ? JSON.stringify(event.onlineLink)
      : '';

    this.pendingUpdates.set(event.id,  Date.now());  

    this.putEventFetchService.updateTemplate(
      event.title, 
      event.location, 
      event.start, 
      event.end, 
      event.description,
      event.status, 
      event.ticketno, 
      event.customer, 
      event.category,
      event.id, 
      event.color, 
      event.cost, 
      event.type,
      event.online, 
      onlineLinkString, 
      event.dolmetscher,
      event.vorbereitungsmaterial, 
      event.vorbereitungsmaterialLink,
      event.bufferBefore, 
      event.bufferAfter, 
      event.traveltime,
      false, 
      event.traveltimeBefore,
      event.traveltimeAfter,
      event.informations,
      event.aufzeichnung,
      event.vorbereitung,
      event.vorbereitungZeit,
      event.abrechnungArt,
      event.fremdCoAbrechnung,
      event.bestaetigungsform
    ).subscribe({
      next: (response: any) => {
        //pending entfernen
        this.pendingUpdates.delete(response.id);

        //DAS ist dein "local update"
        this.processUpdatedTemplate(response, 'local');

        // UI Feedback
        this.popupCloseAfterEventUpdate = true;
        setTimeout(() => (this.popupCloseAfterEventUpdate = false));
        this.toastService.successToast('Termin aktualisiert');
      },
      error: (err) => {
        console.error('Create failed:', err);
      }
    });
        
    //this.myEvents = [...this.myEvents];
    this.popupCloseAfterTemplateUpdate = true;
    setTimeout(() => (this.popupCloseAfterTemplateUpdate = false));
  }

// async customerSearchFiltering(filterText: string): Promise<any[]> {
//   const data = await this.getCustomerService.fetchCustomerSearch(filterText);

//   const foundCustomers: any[] = [];
//   if (data) {
//     console.log('CUSTOMERS FOUND -->', data);
//     for (const customer of data) {
//       const customerName = customer.firstname + ' ' + customer.lastname;
//       foundCustomers.push({ text: customerName, value: customer.id });
//     }
//     this.filteredCustomers = foundCustomers;
//   }

//   return this.filteredCustomers;
// }
// TESTEN
async customerSearchFiltering(filterText: string): Promise<any[]> {
  const data = await this.getCustomerService.fetchCustomerSearch(filterText);

  this.filteredCustomers = Array.isArray(data)
    ? data.map(customer => ({
        text: `${customer.firstname} ${customer.lastname}`,
        value: customer.id
      }))
    : [];

  return this.filteredCustomers;
}

 // Abruf der Resourcen
  fetchInterpreters() {
  this.fetchUserService.fetchInterpreters().subscribe(
    (users: any) => {
      const Interpreter: Resource[] = users.map((user: any) => ({
        id: user.id,
        cr: user.abbreviation,
        name: `${user.firstName.trim()} ${user.lastName}`,
        color: user.color,
        img: user.img,
        workingHours: user.workingHours,
        workingType: user.workingType,
        team: user.team
      }));

      if (this.myResources) {
        this.myResources = Interpreter;
      }
    },
    error => {
      console.error("Fehler beim Abrufen der Dolmetscher:", error);
    }
  );
  }

  postEventFromLib(event: any) {
    this.postEventFetchService.uploadEvent(
      event.start, 
      event.end,
      event.title, 
      event['location'],
      event['cost'], 
      event['description'],
      event['category'], 
      event['status'], 
      event['ticketno'], 
      event['customer'], 
      [null], 
      event.color,
      event['online'] ,
      JSON.stringify(event['onlineLink']),
      event['vorbereitungsmaterial'],
      event['vorbereitungsmaterialLink'] ,
      event['buffeBefore'],
      event['bufferAfter'],
      event['traveltime'],
      false,
      event['type'],
      event['isTemplate'],
      event.recurring,
      event.recurringException,
      event['dialinTime'],
      event['minuteBased'],
      event['subtypes'],
      event['informations'],
      event['traveltimeBefore'],
      event['traveltimeAfter'],
      event['dolmetscher'],
      event['einsatzzeit'],
      event['bestaetigungsform'],
      event['aufzeichnung'],
      event['vorbereitung'],
      event['vorbereitungZeit'],
      event['abrechnungArt'],
      event['fremdCoAbrechnung']
    ).subscribe({
    next: (response: any) => {
      this.backlogEventCreated.emit(response)
      },
      error: (err) => {
        console.error('Create failed:', err);
      }
    });
    //this.myEvents.push(this.tempEvent);
    //this.myEvents = [...this.myEvents];  
    this.popupCloseAfterEventPost = true;
    setTimeout(() => (this.popupCloseAfterEventPost = false));  
  }


  updateEventFromLib(event: any) {
    const existingEvent = this.filteredTasks.find(e => Number(e.id) === Number(event.id));
    if (!existingEvent) {
      event.resource = [null];
    } else {
      event.resource = existingEvent.resource;
    }

    this.pendingUpdate.emit({id: event.id, time: Date.now()});

    this.putEventFetchService.updateEvent(
      event.title, 
      event.location, 
      event.notes,
      event.start, 
      event.end, 
      event.resource, 
      event.description,
      event.status, 
      event.ticketno, 
      event.customer, 
      event.category,
      event.id, 
      event.color, 
      event.cost, 
      event.type,
      event.online, 
      JSON.stringify(event.onlineLink),
      event.dolmetscher,
      event.vorbereitungsmaterial, 
      event.vorbereitungsmaterialLink,
      event.bufferBefore, 
      event.bufferAfter, 
      event.traveltime,
      false, 
      event.isTemplate, 
      event.recurring, 
      event.recurringException,
      event.dialinTime,
      event.minuteBased,
      event.subtypes,
      JSON.stringify(event.informations),
      event.traveltimeBefore,
      event.traveltimeAfter,
      event.einsatzzeit,
      event.bestaetigungsform,
      event.aufzeichnung,
      event.vorbereitung,
      event.vorbereitungZeit,
      event.abrechnungArt,
      event.fremdCoAbrechnung,
      event['ueberprueft'],
      event['resourceMeta']
    ).subscribe({
    next: (response: any) => {
      this.backlogEventUpdated.emit(response)
      },
      error: (err) => {
        console.error('Create failed:', err);
      }
    });

    this.myEvents = [...this.myEvents];
    this.popupCloseAfterEventUpdate = true;
    setTimeout(() => (this.popupCloseAfterEventUpdate = false));
  }


toggleSection(section: any) {
  
  if(section === 'backlog') {
    if(!this.toggleStatusBacklog) {
      this.toggleStatusBacklog = true
      localStorage.setItem('toggleBacklog', 'true')
    } else {
      this.toggleStatusBacklog = false
      localStorage.setItem('toggleBacklog', 'false')
    }
  } else if (section === 'template') {
    if(!this.toggleStatusTemplate) {
      this.toggleStatusTemplate = true
      localStorage.setItem('toggleTemplate', 'true')
    } else {
      this.toggleStatusTemplate = false
      localStorage.setItem('toggleTemplate', 'false')
    }
  }

}


  onRightClick(mouseEvent: MouseEvent, event: any): void {
    mouseEvent.preventDefault(); // Standard-Kontextmenü unterdrücken

    if (event.start && event.end) {
      this.eventSelected.emit({
        start: new Date(event.start),
        end: new Date(event.end),
      });
    }
  }


  async getCustomerSearchFromLib(filterText: any) {
   const data = await this.getCustomerService.fetchCustomerSearch(filterText);

  const foundCustomers: any[] = [];
  if (data) {
    console.log('CUSTOMERS FOUND -->', data);
    for (const customer of data) {
      const customerName = customer.firstname + ' ' + customer.lastname;
      foundCustomers.push({ text: customerName, value: customer.id });
    }
    this.filteredCustomers = foundCustomers;
  }
// console.log( this.filteredCustomers)
  return this.filteredCustomers;
  }

deleteEventFromLib(event: any) {
  this.myEvents = this.myEvents.filter((item) => item.id !== event.id);

  this.deleteEventFetchService.deleteEvent(event)
    .then((res) => {
      console.log('Event gelöscht:', res);
      this.popupCloseAfterEventDelete = true;
      setTimeout(() => (this.popupCloseAfterEventDelete = false));
    })
    .catch((err) => console.error('Fehler beim Löschen:', err));
}

async getHistoryData(id: any) {
    if (!id) return;

    try {
      const data = await this.eventHistoryService.fetchEventHistory(id).toPromise();

      const nullOrEmptyFields = [
        'vorbereitungsmaterialLink',
        'description',
        'category',
        'onlineLink',
        'dolmetscher',
        'ticketno',
        'vorbereitungsmaterial'
      ];

      const excludedFields = [
        'color', 'blocker', 'blockerRef', 'bufferAfter', 'bufferBefore',
        'calculateTraveltime', 'cost', 'dialinTime', 'id', 'minuteBased',
        'offeneTermine', 'recurringException', 'subtypes', 'traveltime',
        'traveltimeAfter', 'traveltimeBefore', 'recurring'
      ];

      this.historyData = data.filter((entry: any) => {
        if (excludedFields.includes(entry.fieldName)) return false;

        if (entry.fieldName === 'customer' && entry.fieldValueFrom === '0' && entry.fieldValueTo === '[]') {
          return false;
        }

        if (entry.fieldName === 'vorbereitungsmaterial' && entry.fieldValueFrom === 'false' && entry.fieldValueTo === '"0"') {
          return false;
        }

        if (
          nullOrEmptyFields.includes(entry.fieldName) &&
          (
            ((entry.fieldValueFrom === '""' || entry.fieldValueFrom === 'null') &&
             (entry.fieldValueTo === '""' || entry.fieldValueTo === 'null')) ||
            ((entry.fieldValueFrom === 'null' || entry.fieldValueFrom === '0') &&
             (entry.fieldValueTo === 'null' || entry.fieldValueTo === '0')) ||
            ((entry.fieldValueFrom === 'null' || entry.fieldValueFrom === 'false') &&
             (entry.fieldValueTo === 'null' || entry.fieldValueTo === 'false'))
          )
        ) {
          return false;
        }

        if (['start', 'end'].includes(entry.fieldName)) {
          try {
            const fromDate = new Date(JSON.parse(entry.fieldValueFrom));
            const toDate = new Date(JSON.parse(entry.fieldValueTo));

            const fromTime = fromDate.getUTCHours() * 60 + fromDate.getUTCMinutes();
            const toTime = toDate.getUTCHours() * 60 + toDate.getUTCMinutes();

            if (fromTime === toTime) {
              return false;
            }
          } catch (e) {
            console.warn('Fehler beim Datum-Vergleich:', e);
          }
        }

        return true;
      });

      console.log('History-Data (gefiltert):', this.historyData);
      this.groupHistoryEntries();
    } catch (err) {
      console.error('Fehler beim Laden der Historie:', err);
    }
  }

  groupHistoryEntries() {
    const map = new Map();

    for (const entry of this.historyData) {
      const timestamp = this.formatTimestamp(entry.changeDate);
      const user = entry.kuerzel || entry.userID || 'Unbekannt';
      const key = `${timestamp}|${user}`;

      if (!map.has(key)) {
        map.set(key, {
          timestamp: entry.changeDate,
          user: user,
          entries: [],
          open: false
        });
      }

      map.get(key).entries.push(entry);
    }

    this.groupedHistory = Array.from(map.values()).sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });
  }

  formatTimestamp(date: string) {
    const d = new Date(date);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.toISOString();
  }

  async formatDateToString(date: any){
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  getUserId(){
    const userData = localStorage.getItem('authUser');

    if(userData){ // nur wenn userData nicht null
      const parsedData = JSON.parse(userData);
      const userId = parsedData.id == undefined ? parsedData.user.id : parsedData.id;
      //console.log('USER_ID:', userId);
      return userId;

    } else {
      console.warn('Kein User(ID) im localStorage gefunden');
    }
  }

    async getTravelTimeWithGoogle(destination: string) {
    try {
      const data = await this.traveltimeService.getTraveltime(destination);

      if (data) {
        const duration = data.duration;
        this.travelTimeData = {
          duration,
          destination: data.destination_addresses[0]
        };

        this.toastService.successToast(`Berechnete Zeit: ${duration} Minuten`);
      } else {
        console.error('Keine gültige Distanz-/Zeitinfo erhalten:', data);
      }

    } catch (error) {
      console.error('Fehler beim Abrufen der Reisezeit:', error);
      this.toastService.dangerToast('Fehler beim Abrufen der Reisezeit.');
    }
  }

}


